<div class="chart-container" [ngClass]="{'mobile-ui': showMobileUi}">
    <canvas baseChart [data]="stackedBarChartData" [options]="stackedBarChartOptions" type="bar">
    </canvas>
</div>
